import {Basic, Ventrata} from 'types'

export const getUnitPricing = (
  unitOrOption: Ventrata.Unit | Ventrata.Option,
  currency: Basic.Currency,
  field: 'pricingFrom' | 'pricing'
) => {
  const pricingList = unitOrOption[field]

  if (!pricingList) {
    return null
  }

  const pricingItem = pricingList.find((item) => item.currency === currency)
  return pricingItem
}
